import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { Mock } from 'types/global'
//
export const MocksLocationServiceNow:Mock[] = [ 
    { 
        'url': ROUTES_NAMES.location.post.update_sector_location_status, 
        'method': 'POST', 
        'data': {
            "result": {
                "sys_id": "413e874b1bce611060d9426fe54bcbec",
                "number": "NTI0001030",
                "record": "api/now/table/x_rdsls_notificabe_interactions/413e874b1bce611060d9426fe54bcbec",
                "redirect_portal_url": "",
                "redirect_url": "x_rdsls_notificabe_interactions.do?sys_id=413e874b1bce611060d9426fe54bcbec&sysparm_view=",
                "table": "x_rdsls_notificabe_interactions",
                "redirect_to": "generated_record"
            }
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`365a75fe1bfa7810bcd687bfe54bcb0e`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`635af5fe1bfa7810bcd687bfe54bcb36`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`8f5a75fe1bfa7810bcd687bfe54bcbfd`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`135ab5fe1bfa7810bcd687bfe54bcb9d`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`275af5fe1bfa7810bcd687bfe54bcb3d`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`535ab5fe1bfa7810bcd687bfe54bcb34`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`6b5ab5fe1bfa7810bcd687bfe54bcbfa`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`935ab5fe1bfa7810bcd687bfe54bcbac`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`196752921b101d104e95a68fe54bcb18`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`2b5af5fe1bfa7810bcd687bfe54bcb09`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`575ab5fe1bfa7810bcd687bfe54bcba2`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`835a75fe1bfa7810bcd687bfe54bcbba`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`975ab5fe1bfa7810bcd687bfe54bcbc9`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`1e6fed271bec5d1060d9426fe54bcb8c`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`2f5af5fe1bfa7810bcd687bfe54bcb00`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`5b5ab5fe1bfa7810bcd687bfe54bcbc3`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`875a75fe1bfa7810bcd687bfe54bcbbb`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`9f5ab5fe1bfa7810bcd687bfe54bcb32`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`a35ab5fe1bfa7810bcd687bfe54bcbfd`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': []
        }
    },
    { 
        'url': ROUTES_NAMES.user.get.by_location_id_and_profile(`235af5fe1bfa7810bcd687bfe54bcb02`, 'location_manager'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    "sys_id": {
                        "display_value": "05f326d81b79a91060d9426fe54bcb39",
                        "value": "05f326d81b79a91060d9426fe54bcb39"
                    },
                    "u_sector": {
                        "display_value": "Recepção",
                        "link": "https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c",
                        "value": "75637fa9dba12110839481640496191c"
                    },
                    "u_user.email": {
                        "display_value": "nadaparaver@email.com.br",
                        "value": "nadaparaver@email.com.br"
                    },
                    "u_active": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_location": {
                        "display_value": "SP - Hospital e Maternidade Assunção",
                        "link": "https://rdsldev.service-now.com/api/now/table/cmn_location/235af5fe1bfa7810bcd687bfe54bcb02",
                        "value": "235af5fe1bfa7810bcd687bfe54bcb02"
                    },
                    "u_profile": {
                        "display_value": "Gestor da unidade",
                        "value": "location_manager"
                    },
                    "u_user": {
                        "display_value": "Fernanda Cristina do Carmo",
                        "link": "https://rdsldev.service-now.com/api/now/table/sys_user/b289d7c41bc2f4106adcea8ce54bcb78",
                        "value": "b289d7c41bc2f4106adcea8ce54bcb78"
                    }
                },
                {
                    "sys_id": {
                        "display_value": "1e93b3e9dba1211083948164049619c9",
                        "value": "1e93b3e9dba1211083948164049619c9"
                    },
                    "u_sector": {
                        "display_value": "Recepção",
                        "link": "https://rdsldev.service-now.com/api/now/table/x_rdsls_notificabe_sectors/75637fa9dba12110839481640496191c",
                        "value": "75637fa9dba12110839481640496191c"
                    },
                    "u_user.email": {
                        "display_value": "nadaparaver@email.com.br",
                        "value": "nadaparaver@email.com.br"
                    },
                    "u_active": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_location": {
                        "display_value": "SP - Hospital e Maternidade Assunção",
                        "link": "https://rdsldev.service-now.com/api/now/table/cmn_location/235af5fe1bfa7810bcd687bfe54bcb02",
                        "value": "235af5fe1bfa7810bcd687bfe54bcb02"
                    },
                    "u_profile": {
                        "display_value": "Gestor da unidade",
                        "value": "location_manager"
                    },
                    "u_user": {
                        "display_value": "Daniel Aguiar Gallante Reis",
                        "link": "https://rdsldev.service-now.com/api/now/table/sys_user/ff96929d1b9f09504e95a68fe54bcbef",
                        "value": "ff96929d1b9f09504e95a68fe54bcbef"
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '0', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital e Maternidade Assunção - Mock',
                        'value': '235af5fe1bfa7810bcd687bfe54bcb02'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'BA - Hospital São Rafael',
                        'value': '365a75fe1bfa7810bcd687bfe54bcb0e'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Onco Star Clinica JK',
                        'value': '635af5fe1bfa7810bcd687bfe54bcb36'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Hospital Esperança Olinda',
                        'value': '8f5a75fe1bfa7810bcd687bfe54bcbfd'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet - Barra',
                        'value': '135ab5fe1bfa7810bcd687bfe54bcb9d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'MG - Hospital Biocor',
                        'value': '275af5fe1bfa7810bcd687bfe54bcb3d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('054333e9dba12110839481640496192a', '0', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital e Maternidade Assunção - Mock',
                        'value': '235af5fe1bfa7810bcd687bfe54bcb02'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'BA - Hospital São Rafael',
                        'value': '365a75fe1bfa7810bcd687bfe54bcb0e'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Onco Star Clinica JK',
                        'value': '635af5fe1bfa7810bcd687bfe54bcb36'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Hospital Esperança Olinda',
                        'value': '8f5a75fe1bfa7810bcd687bfe54bcbfd'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet - Barra',
                        'value': '135ab5fe1bfa7810bcd687bfe54bcb9d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'MG - Hospital Biocor',
                        'value': '275af5fe1bfa7810bcd687bfe54bcb3d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '1', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'BA - Hospital São Rafael',
                        'value': '365a75fe1bfa7810bcd687bfe54bcb0e'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Onco Star Clinica JK',
                        'value': '635af5fe1bfa7810bcd687bfe54bcb36'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Hospital Esperança Olinda',
                        'value': '8f5a75fe1bfa7810bcd687bfe54bcbfd'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet - Barra',
                        'value': '135ab5fe1bfa7810bcd687bfe54bcb9d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'MG - Hospital Biocor',
                        'value': '275af5fe1bfa7810bcd687bfe54bcb3d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '2', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Onco Star Clinica JK',
                        'value': '635af5fe1bfa7810bcd687bfe54bcb36'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Hospital Esperança Olinda',
                        'value': '8f5a75fe1bfa7810bcd687bfe54bcbfd'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet - Barra',
                        'value': '135ab5fe1bfa7810bcd687bfe54bcb9d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'MG - Hospital Biocor',
                        'value': '275af5fe1bfa7810bcd687bfe54bcb3d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '3', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Hospital Esperança Olinda',
                        'value': '8f5a75fe1bfa7810bcd687bfe54bcbfd'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet - Barra',
                        'value': '135ab5fe1bfa7810bcd687bfe54bcb9d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'MG - Hospital Biocor',
                        'value': '275af5fe1bfa7810bcd687bfe54bcb3d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - DF Star',
                        'value': '835a75fe1bfa7810bcd687bfe54bcbba'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '4', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet - Barra',
                        'value': '135ab5fe1bfa7810bcd687bfe54bcb9d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'MG - Hospital Biocor',
                        'value': '275af5fe1bfa7810bcd687bfe54bcb3d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - DF Star',
                        'value': '835a75fe1bfa7810bcd687bfe54bcbba'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hosp SL - Itaim',
                        'value': '975ab5fe1bfa7810bcd687bfe54bcbc9'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '5', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'MG - Hospital Biocor',
                        'value': '275af5fe1bfa7810bcd687bfe54bcb3d'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - DF Star',
                        'value': '835a75fe1bfa7810bcd687bfe54bcbba'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hosp SL - Itaim',
                        'value': '975ab5fe1bfa7810bcd687bfe54bcbc9'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Maxclínicas - Memorial São José',
                        'value': '1e6fed271bec5d1060d9426fe54bcb8c'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '6', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital da Criança - Instituto',
                        'value': '535ab5fe1bfa7810bcd687bfe54bcb34'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - DF Star',
                        'value': '835a75fe1bfa7810bcd687bfe54bcbba'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hosp SL - Itaim',
                        'value': '975ab5fe1bfa7810bcd687bfe54bcbc9'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Maxclínicas - Memorial São José',
                        'value': '1e6fed271bec5d1060d9426fe54bcb8c'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital de Clínicas Antonio Afonso',
                        'value': '2f5af5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '7', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Brasil Mauá (América)',
                        'value': '6b5ab5fe1bfa7810bcd687bfe54bcbfa'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'true',
                        'value': 'true'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - DF Star',
                        'value': '835a75fe1bfa7810bcd687bfe54bcbba'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hosp SL - Itaim',
                        'value': '975ab5fe1bfa7810bcd687bfe54bcbc9'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Maxclínicas - Memorial São José',
                        'value': '1e6fed271bec5d1060d9426fe54bcb8c'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital de Clínicas Antonio Afonso',
                        'value': '2f5af5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Clínica São Remo',
                        'value': '5b5ab5fe1bfa7810bcd687bfe54bcbc3'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '8', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Perinatal Barra',
                        'value': '935ab5fe1bfa7810bcd687bfe54bcbac'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - DF Star',
                        'value': '835a75fe1bfa7810bcd687bfe54bcbba'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hosp SL - Itaim',
                        'value': '975ab5fe1bfa7810bcd687bfe54bcbc9'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Maxclínicas - Memorial São José',
                        'value': '1e6fed271bec5d1060d9426fe54bcb8c'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital de Clínicas Antonio Afonso',
                        'value': '2f5af5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Clínica São Remo',
                        'value': '5b5ab5fe1bfa7810bcd687bfe54bcbc3'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - Hospital do Coração do Brasil',
                        'value': '875a75fe1bfa7810bcd687bfe54bcbbb'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.location.get.by_sector_id_paginate('00222d8adb25611083948164049619f6', '9', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PA - Hospital 5 de Outubro',
                        'value': '196752921b101d104e95a68fe54bcb18'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital Villa Lobos',
                        'value': '2b5af5fe1bfa7810bcd687bfe54bcb09'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Laboratório  Richet  - Copacabana',
                        'value': '575ab5fe1bfa7810bcd687bfe54bcba2'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - DF Star',
                        'value': '835a75fe1bfa7810bcd687bfe54bcbba'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hosp SL - Itaim',
                        'value': '975ab5fe1bfa7810bcd687bfe54bcbc9'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'PE - Maxclínicas - Memorial São José',
                        'value': '1e6fed271bec5d1060d9426fe54bcb8c'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Hospital de Clínicas Antonio Afonso',
                        'value': '2f5af5fe1bfa7810bcd687bfe54bcb00'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'SP - Clínica São Remo',
                        'value': '5b5ab5fe1bfa7810bcd687bfe54bcbc3'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'DF - Hospital do Coração do Brasil',
                        'value': '875a75fe1bfa7810bcd687bfe54bcbbb'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                },
                {
                    'x_rdsls_notificabe_locations': {
                        'display_value': 'RJ - Hospital Copa Star',
                        'value': '9f5ab5fe1bfa7810bcd687bfe54bcb32'
                    },
                    'x_rdsls_notificabe_sectors': {
                        'display_value': 'Programação Avançada',
                        'value': '00222d8adb25611083948164049619f6'
                    },
                    'u_active': {
                        'display_value': 'false',
                        'value': 'false'
                    }
                }
            ]
        }
    },
    {
        'url': ROUTES_NAMES.location.get.all(), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'sys_id': '075ab5fe1bfa7810bcd687bfe54bcb00',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Hospital São Marcos'
                },
                {
                    'sys_id': '0b5ab5fe1bfa7810bcd687bfe54bcb01',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Hospital Memorial São José'
                },
                {
                    'sys_id': '0db247ed1be45d504e95a68fe54bcba6',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Maternidade Star'
                },
                {
                    'sys_id': '0dc18b6d1be45d504e95a68fe54bcb1a',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Campinas',
                    'name': 'SP - Hospital Campinas'
                },
                {
                    'sys_id': '135ab5fe1bfa7810bcd687bfe54bcb9d',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - BARRA'
                },
                {
                    'sys_id': '138247ed1be45d504e95a68fe54bcb40',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Maternidade São José'
                },
                {
                    'sys_id': '175ab5fe1bfa7810bcd687bfe54bcb48',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Oeste D\'Or'
                },
                {
                    'sys_id': '175ab5fe1bfa7810bcd687bfe54bcba1',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - CENTRO'
                },
                {
                    'sys_id': '196752921b101d104e95a68fe54bcb18',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Canaã dos Carajas',
                    'name': 'PA - Hospital 5 de Outubro'
                },
                {
                    'sys_id': '1b5ab5fe1bfa7810bcd687bfe54bcb36',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Israelita'
                },
                {
                    'sys_id': '1b5ab5fe1bfa7810bcd687bfe54bcb45',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Niterói',
                    'name': 'RJ - Hospital Niterói D\'Or'
                },
                {
                    'sys_id': '1b61436d1be45d504e95a68fe54bcb55',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Salvador',
                    'name': 'BA - Hospital Aeroporto'
                },
                {
                    'sys_id': '1e6fed271bec5d1060d9426fe54bcb8c',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Maxclínicas - Memorial São José'
                },
                {
                    'sys_id': '1f5ab5fe1bfa7810bcd687bfe54bcb37',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Jutta Batista'
                },
                {
                    'sys_id': '1f5ab5fe1bfa7810bcd687bfe54bcba8',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - RECREIO'
                },
                {
                    'sys_id': '235ab5fe1bfa7810bcd687bfe54bcbf8',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Caetano do Sul',
                    'name': 'SP - Hosp SL - São Caetano do Sul'
                },
                {
                    'sys_id': '235af5fe1bfa7810bcd687bfe54bcb02',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Bernardo do Campo',
                    'name': 'SP - Hospital e Maternidade Assunção'
                },
                {
                    'sys_id': '235af5fe1bfa7810bcd687bfe54bcb07',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hospital Serra Mayor'
                },
                {
                    'sys_id': '275af5fe1bfa7810bcd687bfe54bcb03',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Santo André',
                    'name': 'SP - Hospital e Maternidade Brasil'
                },
                {
                    'sys_id': '275af5fe1bfa7810bcd687bfe54bcb08',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Osasco',
                    'name': 'SP - Hospital e Maternidade São Luiz Osasco (Sino Brasileiro)'
                },
                {
                    'sys_id': '275af5fe1bfa7810bcd687bfe54bcb3d',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Belo Horizonte',
                    'name': 'MG - Hospital Biocor'
                },
                {
                    'sys_id': '2b5ab5fe1bfa7810bcd687bfe54bcbf4',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hosp SL - Morumbi'
                },
                {
                    'sys_id': '2b5ab5fe1bfa7810bcd687bfe54bcbff',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hospital da Criança'
                },
                {
                    'sys_id': '2b5af5fe1bfa7810bcd687bfe54bcb04',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Bernardo do Campo',
                    'name': 'SP - Hospital Ifor'
                },
                {
                    'sys_id': '2b5af5fe1bfa7810bcd687bfe54bcb09',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hospital Villa Lobos'
                },
                {
                    'sys_id': '2bae58a91b5819104e95a68fe54bcb15',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hospital Santa Isabel'
                },
                {
                    'sys_id': '2beeed671bec5d1060d9426fe54bcb12',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Olinda',
                    'name': 'PE - Maxclínicas - Esperança Olinda'
                },
                {
                    'sys_id': '2f5ab5fe1bfa7810bcd687bfe54bcbcc',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hosp SL - Jabaquara (HNSL)'
                },
                {
                    'sys_id': '2f5af5fe1bfa7810bcd687bfe54bcb00',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Jacareí',
                    'name': 'SP - Hospital de Clínicas Antonio Afonso'
                },
                {
                    'sys_id': '2f5af5fe1bfa7810bcd687bfe54bcb05',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Ribeirão Pires',
                    'name': 'SP - Hospital Ribeirão Pires'
                },
                {
                    'sys_id': '2f5af5fe1bfa7810bcd687bfe54bcb0a',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São José dos Campos',
                    'name': 'SP - Hospital viValle'
                },
                {
                    'sys_id': '325a35fe1bfa7810bcd687bfe54bcb51',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Salvador',
                    'name': 'BA - Hospital Aliança'
                },
                {
                    'sys_id': '365a75fe1bfa7810bcd687bfe54bcb0e',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Salvador',
                    'name': 'BA - Hospital São Rafael'
                },
                {
                    'sys_id': '435ab5fe1bfa7810bcd687bfe54bcb06',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Clínica Mediax'
                },
                {
                    'sys_id': '475ab5fe1bfa7810bcd687bfe54bcb21',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Olinda',
                    'name': 'PE - Prontimagem'
                },
                {
                    'sys_id': '4b5a75fe1bfa7810bcd687bfe54bcbd5',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Brasília',
                    'name': 'DF - Hospital Santa Helena'
                },
                {
                    'sys_id': '535ab5fe1bfa7810bcd687bfe54bcb34',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital da Criança - Instituto'
                },
                {
                    'sys_id': '535ab5fe1bfa7810bcd687bfe54bcb9e',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - BNDES'
                },
                {
                    'sys_id': '575ab5fe1bfa7810bcd687bfe54bcb35',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Glória D\'Or'
                },
                {
                    'sys_id': '575ab5fe1bfa7810bcd687bfe54bcb4c',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Rio Mar'
                },
                {
                    'sys_id': '575ab5fe1bfa7810bcd687bfe54bcba2',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - COPACABANA'
                },
                {
                    'sys_id': '5b5ab5fe1bfa7810bcd687bfe54bcb27',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Clínica São Vicente'
                },
                {
                    'sys_id': '5b5ab5fe1bfa7810bcd687bfe54bcb4d',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Rios D\'Or'
                },
                {
                    'sys_id': '5b5ab5fe1bfa7810bcd687bfe54bcba5',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - MATRIZ'
                },
                {
                    'sys_id': '5b5ab5fe1bfa7810bcd687bfe54bcbc3',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Clínica São Remo'
                },
                {
                    'sys_id': '5bd1cb6d1be45d504e95a68fe54bcb1d',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'João Pessoa',
                    'name': 'PB - Hospital Nossa Senhora Das Neves'
                },
                {
                    'sys_id': '5f5ab5fe1bfa7810bcd687bfe54bcb46',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Norte D\'Or'
                },
                {
                    'sys_id': '5f5ab5fe1bfa7810bcd687bfe54bcba9',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - SÃO VICENTE'
                },
                {
                    'sys_id': '635af5fe1bfa7810bcd687bfe54bcb36',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Onco Star Clinica JK'
                },
                {
                    'sys_id': '635af5fe1bfa7810bcd687bfe54bcb3b',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Taboão da Serra',
                    'name': 'SP - Policlínica Taboão'
                },
                {
                    'sys_id': '675ab5fe1bfa7810bcd687bfe54bcbf9',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Carapicuíba',
                    'name': 'SP - Hospital Alpha-Med'
                },
                {
                    'sys_id': '675af5fe1bfa7810bcd687bfe54bcb37',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Onco Star Farmácia'
                },
                {
                    'sys_id': '6b5ab5fe1bfa7810bcd687bfe54bcbfa',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Mauá',
                    'name': 'SP - Hospital Brasil Mauá (América)'
                },
                {
                    'sys_id': '6f5af5fe1bfa7810bcd687bfe54bcb39',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Vila Nova Star'
                },
                {
                    'sys_id': '7a5a75fe1bfa7810bcd687bfe54bcb0f',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Fortaleza',
                    'name': 'CE - Hospital São Carlos'
                },
                {
                    'sys_id': '7b5af5fe1bfa7810bcd687bfe54bcba2',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - PG12'
                },
                {
                    'sys_id': '835a75fe1bfa7810bcd687bfe54bcbba',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Brasília',
                    'name': 'DF - DF Star'
                },
                {
                    'sys_id': '835a75fe1bfa7810bcd687bfe54bcbdb',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Brasília',
                    'name': 'DF - Clínica Salute'
                },
                {
                    'sys_id': '835a75fe1bfa7810bcd687bfe54bcbe0',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Campo Grande',
                    'name': 'MS - Hospital Proncor'
                },
                {
                    'sys_id': '835ab5fe1bfa7810bcd687bfe54bcb20',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Memorial Star'
                },
                {
                    'sys_id': '875a75fe1bfa7810bcd687bfe54bcbbb',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Brasília',
                    'name': 'DF - Hospital do Coração do Brasil'
                },
                {
                    'sys_id': '89375e121b101d104e95a68fe54bcbba',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Parauapebas',
                    'name': 'PA - Hospital Yutaka Takeda'
                },
                {
                    'sys_id': '8b5a75fe1bfa7810bcd687bfe54bcbfc',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Diagno São Marcos'
                },
                {
                    'sys_id': '8f5a75fe1bfa7810bcd687bfe54bcbde',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Luís',
                    'name': 'MA - Hospital UDI'
                },
                {
                    'sys_id': '8f5a75fe1bfa7810bcd687bfe54bcbfd',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Olinda',
                    'name': 'PE - Hospital Esperança Olinda'
                },
                {
                    'sys_id': '8f5ab5fe1bfa7810bcd687bfe54bcb03',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Maximagem'
                },
                {
                    'sys_id': '935ab5fe1bfa7810bcd687bfe54bcb4b',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Real D\'Or'
                },
                {
                    'sys_id': '935ab5fe1bfa7810bcd687bfe54bcb9f',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - BOTAFOGO'
                },
                {
                    'sys_id': '935ab5fe1bfa7810bcd687bfe54bcbac',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Perinatal Barra'
                },
                {
                    'sys_id': '975ab5fe1bfa7810bcd687bfe54bcb30',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Caxias D\'Or'
                },
                {
                    'sys_id': '975ab5fe1bfa7810bcd687bfe54bcba3',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - IPANEMA'
                },
                {
                    'sys_id': '975ab5fe1bfa7810bcd687bfe54bcbad',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Perinatal Laranjeiras'
                },
                {
                    'sys_id': '975ab5fe1bfa7810bcd687bfe54bcbc9',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hosp SL - Itaim'
                },
                {
                    'sys_id': '9b5ab5fe1bfa7810bcd687bfe54bcb31',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Copa D\'Or'
                },
                {
                    'sys_id': '9b5ab5fe1bfa7810bcd687bfe54bcba6',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Niterói',
                    'name': 'RJ - LABORATÓRIO RICHET - NITERÓI'
                },
                {
                    'sys_id': '9b5ab5fe1bfa7810bcd687bfe54bcbae',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Macaé',
                    'name': 'RJ - São Lucas Hospital de Clínicas'
                },
                {
                    'sys_id': '9f5ab5fe1bfa7810bcd687bfe54bcb32',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Copa Star'
                },
                {
                    'sys_id': '9f5ab5fe1bfa7810bcd687bfe54bcb49',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Quinta D\'Or'
                },
                {
                    'sys_id': '9f5ab5fe1bfa7810bcd687bfe54bcb4e',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Resende',
                    'name': 'RJ - Hospital SAMER'
                },
                {
                    'sys_id': '9f5ab5fe1bfa7810bcd687bfe54bcbaa',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - TIJUCA'
                },
                {
                    'sys_id': 'a35ab5fe1bfa7810bcd687bfe54bcbfd',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Santo André',
                    'name': 'SP - Hospital Bartira'
                },
                {
                    'sys_id': 'a75ab5fe1bfa7810bcd687bfe54bcbfe',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hospital Central Leste (Guaianases)'
                },
                {
                    'sys_id': 'a75af5fe1bfa7810bcd687bfe54bcb63',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Clínica Holter'
                },
                {
                    'sys_id': 'a8c0432d1be45d504e95a68fe54bcbd5',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Clínica Cemed Taquara'
                },
                {
                    'sys_id': 'ab5af5fe1bfa7810bcd687bfe54bcb33',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São José dos Campos',
                    'name': 'SP - Hospital viValle - URC'
                },
                {
                    'sys_id': 'ac41cf2d1be45d504e95a68fe54bcb98',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Clínica Sorocaba'
                },
                {
                    'sys_id': 'af5ab5fe1bfa7810bcd687bfe54bcbfb',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hospital Aviccena'
                },
                {
                    'sys_id': 'b65a35fe1bfa7810bcd687bfe54bcb52',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Salvador',
                    'name': 'BA - Hospital Cárdio Pulmonar'
                },
                {
                    'sys_id': 'bd12cf6d1be45d504e95a68fe54bcb7d',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Atibaia',
                    'name': 'SP - Hospital Novo Atibaia'
                },
                {
                    'sys_id': 'c28f29a71bec5d1060d9426fe54bcb4c',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Maxclínicas - São Marcos'
                },
                {
                    'sys_id': 'c35a75fe1bfa7810bcd687bfe54bcbff',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Recife',
                    'name': 'PE - Hospital Esperança Recife'
                },
                {
                    'sys_id': 'c952cbad1be45d504e95a68fe54bcb09',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Feira de Santana',
                    'name': 'BA - Hospital Santa Emília'
                },
                {
                    'sys_id': 'cb5a75fe1bfa7810bcd687bfe54bcbd6',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Brasília',
                    'name': 'DF - Hospital Santa Luzia'
                },
                {
                    'sys_id': 'cb5ab5fe1bfa7810bcd687bfe54bcb23',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Curitiba',
                    'name': 'PR - Hospital Santa Cruz'
                },
                {
                    'sys_id': 'd1728fad1be45d504e95a68fe54bcbaa',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Campo Grande',
                    'name': 'MS - Hospital Santa Marina'
                },
                {
                    'sys_id': 'd35ab5fe1bfa7810bcd687bfe54bcb2a',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Badim'
                },
                {
                    'sys_id': 'd35ab5fe1bfa7810bcd687bfe54bcba0',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - BRS'
                },
                {
                    'sys_id': 'd35ab5fe1bfa7810bcd687bfe54bcbb1',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Aracajú',
                    'name': 'SE - Hospital São Lucas'
                },
                {
                    'sys_id': 'd75ab5fe1bfa7810bcd687bfe54bcb2b',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Balbino'
                },
                {
                    'sys_id': 'd75ab5fe1bfa7810bcd687bfe54bcba4',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - LEBLON'
                },
                {
                    'sys_id': 'd75ab5fe1bfa7810bcd687bfe54bcbb3',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Ambulatório Itaim'
                },
                {
                    'sys_id': 'db5ab5fe1bfa7810bcd687bfe54bcb2c',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Bangu'
                },
                {
                    'sys_id': 'db5ab5fe1bfa7810bcd687bfe54bcba7',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - LABORATÓRIO RICHET - PENÍNSULA'
                },
                {
                    'sys_id': 'dda1c76d1be45d504e95a68fe54bcb9c',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Maceió',
                    'name': 'AL - Hospital Arthur Ramos'
                },
                {
                    'sys_id': 'df5ab5fe1bfa7810bcd687bfe54bcb2d',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - Hospital Barra D`Or'
                },
                {
                    'sys_id': 'df5ab5fe1bfa7810bcd687bfe54bcbc5',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São Paulo',
                    'name': 'SP - Hosp SL - Anália Franco'
                },
                {
                    'sys_id': 'eb5af5fe1bfa7810bcd687bfe54bcb8b',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'Rio de Janeiro',
                    'name': 'RJ - DC39'
                },
                {
                    'sys_id': 'f722c7ad1be45d504e95a68fe54bcb4b',
                    'cmn_location_type': 'Hospital/Clínica/Centro Médico',
                    'city': 'São José dos Campos',
                    'name': 'SP - Hospital Orthoservice'
                }
            ]
        }
    }
]